module.exports = __webpack_public_path__ + "static/media/back.20c803bf.svg";